import { useEffect } from 'react';

import { useJobProspectsStatsActions } from './JobProspectsStatsContext';
import { getMatchScoresStats } from './restApi';

const MatchScoresStatsLoader = () => {
  const { initializeState, onResponse, onError } = useJobProspectsStatsActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getMatchScoresStats({ onResponse, onError });
  }, []);

  return null;
};

export default MatchScoresStatsLoader;
